<template>
    <CCard >      
      <CCardBody>       
        <CRow>      
          <CCol sm="12" lg="12" >  
            <div style="text-align: center; font-size: 15px; border-style:solid; border-color: #ced2d8; border-width:0.5px;border-bottom-width:0px; padding-top: 6px; padding-bottom: 6px;">尚未驗收清單</div>
            <div class="content-wrapper">                            
              <div id="app">                        
                <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                  <ejs-grid ref='uagrid' locale='zh-TW' :dataSource='this.ua_datas' height='200' 
                    :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true' :allowSelection='true'
                    :queryCellInfo='onQueryCellInfo' :toolbar='ua_toolbar' :pageSettings='pageSettings' :beforeRender="beforeRender" :filterSettings='filterSettings' :selectionSettings='selectionSettings' 
                    :toolbarClick="toolbarClick" :rowSelected='rowUASelected' >                             
                    <e-columns>         
                        <e-column type='checkbox' :allowFiltering='false' :allowSorting='false' width='60'></e-column>
                        <e-column field='notify' headerText='通知' width='80' :template="imgTemplate"></e-column> 
                        <e-column field='ua' headerText='採購單號' width='140'></e-column>                          
                        <e-column field='no' headerText='廠商編號' width='140'></e-column> 
                        <e-column field='name' headerText='廠商名稱' width='250' ></e-column>   
                        <e-column field='id' headerText='序號' width='0' :isPrimaryKey='true' ></e-column> 
                        <e-column field='sku_no' headerText='料號' width='160'  ></e-column>              
                        <e-column field='sku_name' headerText='料名' width='260' ></e-column>
                        <e-column field='count' headerText='數量' textAlign='Right' width='120' format="N0" ></e-column>
                        <e-column field='mfgdate' headerText='預計交期' width='140' ></e-column>
                        <e-column field='record1' headerText='備註1' width='160' ></e-column>   
                        <e-column field='record2' headerText='備註2' width='160' ></e-column>  
                        <e-column field='unit' headerText='單位' width='100'></e-column>    
                        <e-column field='status' headerText='狀態' width='160'></e-column>  
                        
                    </e-columns>
                  </ejs-grid>        
                </ejs-tooltip>
              </div>                  
            </div>                
          </CCol>
           
          <CCol sm="12" lg="12" style="margin-top: 10px;" >  
            <div style="text-align: center; font-size: 15px; border-style:solid; border-color: #ced2d8; border-width:0.5px;border-bottom-width:0px; padding-top: 6px; padding-bottom: 6px;">收料單內容</div>
            <div class="content-wrapper">                            
              <div id="app">            
                <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                  <ejs-grid ref='ckgrid' locale='zh-TW' :dataSource='this.ch_datas' height='200' 
                    :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true' :allowSelection='true'
                    :queryCellInfo='onQueryCellInfo' :toolbar='ck_toolbar' :pageSettings='pageSettings' :beforeRender="beforeRender" :filterSettings='filterSettings' :selectionSettings2='selectionSettings' 
                    :toolbarClick="toolbarClick"  :rowSelected='rowSelected'  >                             
                    <e-columns>                   
                        <e-column field='year' headerText='年度' width='120' :isPrimaryKey='true' ></e-column>                          
                        <e-column field='name' headerText='廠商名稱' aria-required="true" :isPrimaryKey='true' width='200'></e-column>              
                        <e-column field='cdate' headerText='填單日期' width='160' :isPrimaryKey='true' ></e-column>   
                        <e-column field='gdate' headerText='收料日期' width='160' :isPrimaryKey='true' ></e-column>                          
                        <!-- <e-column field='material' headerText='物流名稱' width='160'></e-column>    
                        <e-column field='material_name' headerText='物流士名稱' width='160'></e-column>
                        <e-column field='car' headerText='車號' width='160'></e-column>  -->
                        <e-column field='detail' headerText='明細' width='320' :allowFiltering='false'></e-column>
                        <e-column field='sign1' headerText='主管單位' width='160'></e-column>
                        <e-column field='sign2' headerText='驗收人員' width='160'></e-column>
                        <e-column field='sign3' headerText='倉管人員/車輛檢查人員' width='160'></e-column>
                        <e-column field='report' headerText='報表' width='80' :template="urlTemplate" :allowFiltering='false'></e-column>
                    </e-columns>
                  </ejs-grid>        
                </ejs-tooltip>
              </div>                  
            </div>                
          </CCol>

        </CRow>      
        <div class="control-section">
            <ejs-dialog ref="dialogNotifyTemplate" showCloseIcon='true' isModal='true' :visible='false' header='對話視窗' width='1000px' closeOnEscape='true' >
              <NotifyTemplate ref="myNotifyTemplate" v-on:onNotifyTemplateClose="onNotifyTemplateItem"></NotifyTemplate>
            </ejs-dialog>
        </div>   
        <div class="control-section">
          <ejs-dialog ref="modalReceiveDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' 
                :header='is_add ? "新增收料單" : "編輯收料單"' :buttons='dialogFractionButtons' width='1200px'>          
              <div formGroup="orderForm">                       
                <div class="form-row">    
                    <div class="form-group col-md-2">
                        <span class="about-title-verify">年度</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_year" :enabled="false"></ejs-textbox>                              
                    </div>
                    <div class="form-group col-md-2">
                        <span class="about-title-verify">廠商名稱</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_name" :enabled="false"></ejs-textbox>                              
                    </div>
                    <div class="form-group col-md-2">
                        <span class="about-title-verify">收料單號</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_receiptno" :enabled="false"></ejs-textbox>                              
                    </div>
                    <div class="form-group col-md-2">
                        <span class="about-title-verify">填單日期</span>
                        <ejs-datepicker id="datepicker" format="yyyy-MM-dd" v-model="e_cdate" :enabled="true"></ejs-datepicker>                      
                    </div>
                    <div class="form-group col-md-2">
                        <span class="about-title-verify">收料日期</span>
                        <ejs-datepicker id="datepicker" format="yyyy-MM-dd" v-model="e_gdate" :enabled="true"></ejs-datepicker>                  
                    </div>
                    <div class="form-group col-md-12">
                        <span class="about-title-verify">隨貨檢附</span><br>
                        <div style="padding-top: 14px;">
                            <ejs-checkbox label="統一發票" :checked="e_gui" :change="onChangeGUI"></ejs-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                            <ejs-checkbox label="收據" :checked="e_receipt" :change="onChangeReceipt"></ejs-checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                            <ejs-checkbox label="出貨單" :checked="e_order" :change="onChangeOrder"></ejs-checkbox>
                        </div>  
                    </div>
                    <div class="form-group col-md-12">
                      <div class="form-row">
                        <div class="col-md-1 box-header" style="border-top-width:1px; border-left-width:1px; ">
                            項次
                        </div>
                        <div class="col-md-1 box-header" style="border-top-width:1px; ">
                            原物料編號
                        </div>
                        <div class="col-md-2 box-header" style="border-top-width:1px; ">
                            品名規格
                        </div>
                        <div class="col-md-1 box-header" style="border-top-width:1px; ">
                            單位
                        </div>
                        <div class="col-md-1 box-header" style="border-top-width:1px; ">
                            數量
                        </div>
                        <div class="col-md-1 box-header" style="border-top-width:1px; ">
                            收料數量 
                        </div>
                        <div class="col-md-2 box-header" style="border-top-width:1px; ">
                            製造日期 
                        </div>
                        <div class="col-md-2 box-header" style="border-top-width:1px; ">
                            有效日期 
                        </div>
                        <div class="col-md-1 box-header" style="border-top-width:1px; ">
                            備註  
                        </div>
                      </div>                      
                      <div v-for="(item, index) in this.ua_select_data" :key="index">
                        <div class="form-row">
                          <div class="col-md-1 box" style="border-left-width:1px; ">
                              {{  index + 1 }}
                          </div>
                          <div class="col-md-1 box">
                              {{  item.sku_no  }}
                          </div>
                          <div class="col-md-2 box">
                              {{  item.sku_name  }}
                          </div>
                          <div class="col-md-1 box">
                              {{  item.unit  }}
                          </div>
                          <div class="col-md-1 box">
                            <ejs-numerictextbox format='#####' v-model="item.count" floatLabelType="Auto" :showSpinButton='false'  :enabled="false" ></ejs-numerictextbox> 
                          </div>
                          <div class="col-md-1 box">
                            <ejs-numerictextbox format='#####' v-model="item.gcount" floatLabelType="Auto" :showSpinButton='false'  :enabled="true"></ejs-numerictextbox> 
                          </div>
                          <div class="col-md-2 box">
                            <ejs-datepicker ref="MFGDate" v-model="item.mfgdate" format="yyyy-MM-dd"  @focus="openMFGDate(index)"></ejs-datepicker>
                          </div>
                          <div class="col-md-2 box">
                            <ejs-datepicker  ref="ValidDate" v-model="item.validdate" format="yyyy-MM-dd" @focus="openValidDate(index)"></ejs-datepicker>
                          </div>
                          <div class="col-md-1 box">
                            <ejs-textbox floatLabelType="Always" v-model="item.remark" :enabled="true"></ejs-textbox>     
                          </div>
                        </div>
                      </div>
                    </div>                    
                    <div class="form-group col-md-12" style="padding-top: 2px;">
                    </div>
                    <div class="form-group col-md-4">
                        <span class="about-title">物流名稱</span>
                        <ejs-autocomplete :dataSource='o_material' v-model="e_material" ></ejs-autocomplete>                      
                    </div>
                    <div class="form-group col-md-4">
                        <span class="about-title">物流士名稱</span>
                        <ejs-autocomplete :dataSource='o_material_name' v-model="e_material_name"></ejs-autocomplete>                                 
                    </div>
                    <div class="form-group col-md-4">
                        <span class="about-title">車號</span>
                        <ejs-autocomplete :dataSource='o_car' v-model="e_car"></ejs-autocomplete>                               
                    </div>
                    <div class="form-group col-md-12" style="padding-top: 2px;">
                    </div>    
                    <div class="form-group col-md-2">
                        <span class="about-title-verify">車廂清潔無病媒</span><br> 
                        <div style="padding-top: 14px;">
                            <ejs-radiobutton label="是" name="clear" value="yes" :checked="e_clear" :change="onChangeClear"></ejs-radiobutton>&nbsp;&nbsp;&nbsp;&nbsp;
                            <ejs-radiobutton label="否" name="clear" value="no" :checked="!e_clear" :change="onChangeClear"></ejs-radiobutton>
                        </div>                         
                    </div>
                    <div class="form-group col-md-2">
                        <span class="about-title-verify">車廂密閉且上鎖</span><br> 
                        <div style="padding-top: 14px;">
                            <ejs-radiobutton label="是" name="lock" value="yes" :checked="e_lock" :change="onChangeLock"></ejs-radiobutton>&nbsp;&nbsp;&nbsp;&nbsp;
                            <ejs-radiobutton label="否" name="lock" value="no" :checked="!e_lock" :change="onChangeLock"></ejs-radiobutton>
                        </div>                         
                    </div>
                    <div class="form-group col-md-2">
                        <span class="about-title-verify">產品外觀完整無破損</span><br>
                        <div style="padding-top: 14px;">
                            <ejs-radiobutton label="是" name="ndamage" value="yes" :checked="e_ndamage" :change="onChangeNdamage"></ejs-radiobutton>&nbsp;&nbsp;&nbsp;&nbsp;
                            <ejs-radiobutton label="否" name="ndamage" value="no" :checked="!e_ndamage" :change="onChangeNdamage"></ejs-radiobutton>
                        </div>                         
                    </div>
                    <div class="form-group col-md-2">
                        <span class="about-title-verify">滿載</span><br> 
                        <div style="padding-top: 14px;">
                            <ejs-radiobutton label="是" name="fully" value="yes" :checked="e_fully" :change="onChangeFully"></ejs-radiobutton>&nbsp;&nbsp;&nbsp;&nbsp;
                            <ejs-radiobutton label="否" name="fully" value="no" :checked="!e_fully" :change="onChangeFully"></ejs-radiobutton>
                        </div>                         
                    </div>
                    <div class="form-group col-md-2">
                        <span class="about-title-verify">未與有毒性物質同車運送</span><br> 
                        <div style="padding-top: 14px;">
                            <ejs-radiobutton label="是" name="toxicity" value="yes" :checked="e_toxicity" :change="onChangeToxicity"></ejs-radiobutton>&nbsp;&nbsp;&nbsp;&nbsp;
                            <ejs-radiobutton label="否" name="toxicity" value="no" :checked="!e_toxicity" :change="onChangeToxicity"></ejs-radiobutton>
                        </div>                         
                    </div>
                    <div class="form-group col-md-12" style="padding-top: 2px;">
                    </div>                  
                    <div class="form-group col-md-4">
                        <span class="about-title">單位主管</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_unit_supervisor" :enabled="true"></ejs-textbox>                              
                    </div>
                     <div class="form-group col-md-4">
                        <span class="about-title">驗收人員</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_acceptance" :enabled="true"></ejs-textbox>                              
                    </div>
                    <div class="form-group col-md-4">
                        <span class="about-title">倉管人員/車輛檢查人員</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_warehouse_user" :enabled="true"></ejs-textbox>                              
                    </div>
                </div>
            </div>                 
          </ejs-dialog> 
        </div>

        <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>    
      </CCardBody>   
    </CCard>
  </template>
  <style lang="scss" src="../../scss/grid.scss"></style>
  <script>
  
import Vue from "vue";
import { GridComponent, ColumnDirective, ColumnsDirective, Page, Sort, Toolbar, Edit, Filter, ExcelExport } from "@syncfusion/ej2-vue-grids";
import { L10n, enableRipple  } from '@syncfusion/ej2-base';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { NumericTextBoxComponent } from "@syncfusion/ej2-vue-inputs";
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { AutoCompleteComponent } from "@syncfusion/ej2-vue-dropdowns";
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import { RadioButtonComponent, CheckBoxComponent } from "@syncfusion/ej2-vue-buttons";
import NotifyTemplate from "./template/NotifyTemplate.vue";
import zhtwLocalization  from '../language/language.json';

  
L10n.load(zhtwLocalization);
Vue.use(TooltipPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DialogPlugin);
enableRipple(true);
Vue.prototype.$eventHub = new Vue(); 
let DialogObj   = undefined;
let Loader = undefined;

export default {
  components: {
    'ejs-grid': GridComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective,
    'ejs-toast': ToastComponent,
    'ejs-radiobutton': RadioButtonComponent,
    'ejs-checkbox': CheckBoxComponent,
    'ejs-autocomplete': AutoCompleteComponent,
    "ejs-numerictextbox": NumericTextBoxComponent,
    'ejs-datepicker': DatePickerComponent,
    NotifyTemplate,
  },
  provide : {
    grid: [Page, Sort, Toolbar, Edit, Filter, ExcelExport], 
      
  },
  name: 'acceptance_scm',
  data: function() {
    return {
      e_receiptno:null,
      limit : localStorage.getItem('scm'), 
        is_add: false,
        ch_datas : [],
        ua_datas : [], ua_select_data : [],
        e_id: null, e_year : null, e_no : null, e_name : null, e_cdate : null, e_gdate : null,
        e_gui : false, e_receipt : false, e_order : false,
        e_material : null, e_material_name : null, e_car : null,
        o_material : null, o_material_name : null, o_car : null,
        e_clear : true, e_lock : true, e_ndamage : true, e_fully : true, e_toxicity : true,
        e_unit_supervisor : null, e_acceptance : null, e_warehouse_user : null,
        e_selectData: [], e_selectUAData: null,
        dropDownFields: { text: 'text', value: 'value' },
      
        editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
        pageSettings: {pageSize: 50, pageSizes: [10,50,100,200], pageCount: 200 },     
        ua_toolbar: [             
          { text: '收料', tooltipText: '收料', prefixIcon: 'e-btn-icon e-description e-icons e-icon-left', id: 'Receive', disabled : localStorage.getItem('scm').indexOf('33') < 0}, 
          { text: '供應商通知', tooltipText: '供應商通知', prefixIcon: 'e-btn-icon e-annotation-edit e-icons e-icon-left', id: 'Notify', disabled : localStorage.getItem('scm').indexOf('32')< 0 },
          { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'ExportUA' }, 'Search'],   
        ck_toolbar: [             
          { text: '編輯', tooltipText: '編輯', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Detail', disabled : localStorage.getItem('scm').indexOf('33')< 0}, 
          { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete' , disabled : localStorage.getItem('scm').indexOf('33')< 0}, 
          { text: '主管單位', tooltipText: '主管單位', prefixIcon: 'e-btn-icon e-signature e-icons e-icon-left', id: 'Sign1', disabled : localStorage.getItem('scm').indexOf('34') < 0}, 
          { text: '驗收人員 ', tooltipText: '驗收人員', prefixIcon: 'e-btn-icon e-signature e-icons e-icon-left', id: 'Sign2', disabled : localStorage.getItem('scm').indexOf('35')< 0 }, 
          { text: '倉管人員/車輛檢查人員', tooltipText: '倉管人員/車輛檢查人員', prefixIcon: 'e-btn-icon e-signature e-icons e-icon-left', id: 'Sign3', disabled : localStorage.getItem('scm').indexOf('36')< 0 }, 
          { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'ExportWarehourse' }, 'Search'],   
        selectionSettings : { type: 'Multiple', persistSelection: true },
        selectionSettings2: { persistSelection: true },
        filterSettings: { type: 'CheckBox' }, 
     
        visible : false,  

        e_quality: 12, e_delivery_date: 1, e_fit: 2, e_service: 3,        
        position: { X: 'Right', Y: "Bottom" },
        min: 0,
        max: 25,
        shwbuttons: true,
        step: 1,
        checked: false,
        isenable: true,
        readonly: false,
        orientation: "Horizontal", 
        ticks: { placement: 'After', largeStep: 25 },
        type: 'MinRange',

        dialogFractionButtons: [{
            click: this.dialogFractionOkClick,
            buttonModel: { content: '確認', isPrimary: true } 
          }, { 
            click: function() { this.hide(); }, 
            buttonModel: { content: '取消', isPrimary: false}
        }],     
        imgTemplate: function () {
          return {
          template: Vue.component('imgTemplate', {
              template: `<div id="coordinates">
                      <div v-if="data.notify === 0"></div>
                      <div v-if="data.notify === 1"><img src="img/icon/chat.png" class="e-image" width="20px"/></div>
                      <div v-if="data.notify === 2"><img src="img/icon/new-email.png" class="e-image" width="20px"/></div>                                 
                      </div>`,
              data: function () { return { data: {} }; },
              computed: { },
              methods: { }
            })
          }
        },
        urlTemplate: function () {
          return {
              template: Vue.component('yesnoTemplate', {
                  template: `<div id="coordinates">
                          <span id="locationtext"><a @click="doSomething" href="#" ><img src="img/icon/report.png" class="e-image" width="30px" :alt="data.report"/></a></span>        
                          </div>`,
                  data: function () { return { data: {} }; },
                  methods: { 
                      doSomething(e) {
                          e.preventDefault();
                          this.$eventHub.$emit('reporWharehouse',this.data);                               
                      } 
                  }                         
              })
          }
        },
      };
  },
  methods: {  
    openMFGDate(index) {
    // 取得對應的 DatePicker 元件
    const dp = this.$refs['MFGDate'];

    // 如果是 v-for，ref 可能是一個陣列
    const instance = Array.isArray(dp) ? dp[index].ej2Instances : dp.ej2Instances;

    instance.show();  // 呼叫 Syncfusion 的 show()
  },  
    openValidDate(index) {
    // 取得對應的 DatePicker 元件
    const dp = this.$refs['ValidDate'];

    // 如果是 v-for，ref 可能是一個陣列
    const instance = Array.isArray(dp) ? dp[index].ej2Instances : dp.ej2Instances;

    instance.show();  // 呼叫 Syncfusion 的 show()
  },
    onload:function() {
      // 初始化
    },
    submit:function() {
      this.$emit('onGetMaterialsClose');
    },
    beforeRender: function (args) {
      if (args.target.closest("td")) {
        this.$refs.tooltip.content = args.target.innerText;                
      }
    },
    onQualityChange: function(args) {
      this.e_quality = args.value;
    },
    onDeliveryDateChange: function(args) {
      this.e_delivery_date = args.value;
    },
    onFitChange: function(args) {
      this.e_fit = args.value;
    },
    onServiceChange: function(args) {
      this.e_service = args.value;
    },

    rowSelected: function(args) {      
      this.e_selectData = args.data;  
    }, 
    rowUASelected: function(args) {      
      // console.log(args.data);
      this.e_selectUAData = args.data;  
    }, 
    onNotifyTemplateItem:function() {
        this.$refs.dialogNotifyTemplate.hide();  
        this.getWarehourseCheck();
    },
    pubDoubleClick: function () {  
       
    },
    editOkClick: function () {           
      this.upData();         
    },
    valueChange: function () {  
      this.isDataChanged = true;
      this.stTime = null;
    },
    load: function() {   

    },       
    addAction: function() {

    },
    onChangeClear: function(args) {       
      this.e_clear = args.value == 'yes';   
    }, 
    onChangeLock: function(args) {       
      this.e_lock = args.value == 'yes';   
    }, 
    onChangeNdamage: function(args) {       
      this.e_ndamage = args.value == 'yes';   
    }, 
    onChangeFully: function(args) {       
      this.e_fully = args.value == 'yes';   
    }, 
    onChangeToxicity: function(args) {       
      this.e_toxicity = args.value == 'yes';   
    }, 
    onChangeGUI: function(args) {   
      this.e_gui = args.checked;   
    }, 
    onChangeReceipt: function(args) {       
      this.e_receipt = args.checked;     
    }, 
    onChangeOrder: function(args) {       
      this.e_order = args.checked;      
    },
    
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    }, 
    dialogFractionOkClick: function() {
      this.showLoading();
      this.axios({
        method: this.is_add ? 'post' : 'put',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: `/InputCheck/WarehourseCheck`,
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
        data : { 
          datas: this.ua_select_data,
          check: {
            id : this.e_id,
            year : this.e_year,
            receiptno:this.e_receiptno,
            name : this.e_name,
            cdate : this.e_cdate,
            gdate : this.e_gdate,
            gui : this.e_gui,
            receipt : this.e_receipt,
            order : this.e_order,
            material : this.e_material,
            material_name : this.e_material_name,
            car : this.e_car,
            clear: this.e_clear,
            elock: this.e_lock,
            ndamage: this.e_ndamage,
            fully: this.e_fully,
            toxicity: this.e_toxicity,
            unit_supervisor: this.e_unit_supervisor,
            acceptance: this.e_acceptance,
            warehouse_user: this.e_warehouse_user,
          }       
        }
      })
      .then((response) => {
        this.hideLoading();
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });  DialogObj.hide(); return; }    
        this.$toast.open({message: "已建立收料單", type: "success", duration: 5000, dismissible: true})   
        this.$refs.modalReceiveDialog.hide();
        this.getWarehourseCheck();
      })
      .catch((error) => {
        this.hideLoading();
        this.showError(error) }
      )   
    },
    onNotifyTemplate:function() {
        this.$refs.dialogNotifyTemplate.show();  
        this.$refs.myNotifyTemplate.onload(this.e_selectUAData.no, this.e_selectUAData.ua,this.e_selectUAData.sku_no, false);
    }, 
    toolbarClick: function(args) {
      if (args.item.id == "ExportWarehourse") {
        this.$refs.ckgrid.excelExport({ fileName:'收料單內容.xlsx' });
      }
      if (args.item.id == "ExportUA") {
        this.$refs.uagrid.excelExport({ fileName:'未驗收清單.xlsx' });
      }
      if (args.item.id == "Notify") {
        if (this.e_selectUAData == null) {
          this.showMsg('請先選擇一筆資料');
          return;
        }
        this.onNotifyTemplate();
      }
      if (args.item.id == "Report") {
        if (this.e_selectData.length == 0) {
          this.showMsg('至少選擇一個收料單資料');
          return;
        }
        this.is_add = false;        
        this.e_id = this.e_selectData.id; 
        this.onReport();
      }
      if (args.item.id == "Sign1") {
        
        if (this.e_selectData.length == 0) {
          this.showMsg('至少選擇一個收料單資料');
          return;
        }
        this.$swal({
        title: `確認是否進行${this.e_selectData.name}的主管單位簽核?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: '是',
        cancelButtonText: '否'
        }).then((result) => {
          if (result.isConfirmed) {     
            this.addSign(1);
          } else {
            return; 
          }
        });
      }
            if (args.item.id == "Sign2") {

        if (this.e_selectData.length == 0) {
          this.showMsg('至少選擇一個收料單資料');
          return;
        }
           this.$swal({
        title: `確認是否進行${this.e_selectData.name}的驗收人員簽核?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: '是',
        cancelButtonText: '否'
        }).then((result) => {
        if (result.isConfirmed) {     
            this.addSign(2);
        } else {
            return; 
        }
                });
      }
            if (args.item.id == "Sign3") {

        if (this.e_selectData.length == 0) {
          this.showMsg('至少選擇一個收料單資料');
          return;
        }
           this.$swal({
        title: `確認是否進行${this.e_selectData.name}的倉管人員/車輛檢查人員簽核?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: '是',
        cancelButtonText: '否'
        }).then((result) => {
        if (result.isConfirmed) {     
          this.addSign(3);
        } else {
            return; 
        }
        });
      }
      if (args.item.id == "Delete") {
        if (this.e_selectData.length == 0) {
          this.showMsg('至少選擇一個收料單資料');
          return;
        }
        this.e_id = this.e_selectData.id; 
        DialogObj = DialogUtility.confirm({
            title: '資料移除',
            content: `確認是否要移除該收料單資料嗎?`,
            okButton: {  text: '確認', click: this.delWarehourseCheckList },
            cancelButton: {  text: '取消', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });  
      }
      if (args.item.id == "Detail") {      
        if (this.e_selectData.length == 0) {
          this.showMsg('至少選擇一個收料單資料');
          return;
        }
        this.is_add = false;        
        this.e_id = this.e_selectData.id; 
        this.e_year = this.e_selectData.year; 
        this.e_name = this.e_selectData.name; 
        this.e_receiptno = this.e_selectData.receiptno;   
        this.e_cdate = this.e_selectData.cdate; 
        this.e_gdate = this.e_selectData.gdate; 
        this.e_gui = this.e_selectData.gui; 
        this.e_receipt = this.e_selectData.receipt; 
        this.e_order = this.e_selectData.order; 
        this.e_material = this.e_selectData.material; 
        this.e_material_name = this.e_selectData.material_name; 
        this.e_car = this.e_selectData.car; 
        this.e_clear = this.e_selectData.clear; 
        this.e_lock = this.e_selectData.elock; 
        this.e_ndamage = this.e_selectData.ndamage; 
        this.e_fully = this.e_selectData.fully; 
        this.e_toxicity = this.e_selectData.toxicity; 
        
        this.e_unit_supervisor = this.e_selectData.unit_supervisor; 
        this.e_acceptance = this.e_selectData.acceptance; 
        this.e_warehouse_user = this.e_selectData.warehouse_user; 
        this.getWarehourseCheckList();
        this.$refs.modalReceiveDialog.show();
      }    
   
      if (args.item.id == "Receive") {
        let grid = this.$refs.uagrid.ej2Instances;
        this.ua_select_data = grid.getSelectedRecords(); // ✅ 拿到勾選的資料
        // console.log(this.ua_select_data );

        if (this.ua_select_data.length == 0) {
          this.showMsg('至少選擇一個採購資料');
          return;
        }

        let tmpNo = "";
        for (let item of this.ua_select_data) {
          if (tmpNo != "" && tmpNo != item.no) {
            this.showMsg('一張收料清單不可有多個廠商');
            return;          
          } else {
              tmpNo = item.no;
              this.e_no = item.no;
              this.e_name = item.name;
              //取得最新的收料單號
              this.getReceiptNo();
              //  console.log("hello")
          }        
        }
        
        this.e_cdate  = this.formatDate(new Date());
        this.e_gdate  = this.formatDate(new Date());
        this.e_year   = (new Date()).getFullYear();    
        this.is_add   = true;
        this.$refs.modalReceiveDialog.show();
      }
    },   
    onReport: function(args) { 
      // console.log(args);
            fetch(Vue.prototype.GLOBAL.baseURL+`InputCheck/WarehourseCheck/Report?checkid=${args.id}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            })
            .then(res => res.blob())
            .then(blob => {
                    const url = URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                a.download = `${args.cdate} ${args.name} 收料單`; // 留空，瀏覽器就會使用後端回傳的 Content-Disposition 檔名
                document.body.appendChild(a);
                a.click();
                a.remove();

                URL.revokeObjectURL(url);
            });
        },
      addSign: function(arg) {          
        this.axios({
            method: 'post',
            baseURL: Vue.prototype.GLOBAL.baseURL,
            url: `/InputCheck/WarehourseCheck/Sign`,
            headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
            data:{
                id:this.$refs.ckgrid.getSelectedRecords().map(row => row.signid),
                type:arg
            }
        })
        .then((response) => {       
            if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
            this.$refs.toastRef.show( { title: '訊息!', content: "簽名成功", cssClass: 'e-toast-info', icon: 'e-warning toast-icons' });
            this.getWarehourseCheck();
        })
        .catch((error) => { 
            this.showError(error, true) }
        )                 
        
    },
    formatDate(date) {
      let yyyy = date.getFullYear();
      let mm = String(date.getMonth() + 1).padStart(2, '0');      
      let dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    hasDuplicateByKey(arr, key) {
      let seen = new Set();
      for (let item of arr) {
        if (seen.has(item[key])) {
          return true; // 發現重複
        }
        seen.add(item[key]);
      }
      return false;
    },

   
    getWarehourseCheck: function() {    
      this.axios({
        method: 'get',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: `/InputCheck/WarehourseCheck`,
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.ua_datas         = response.data.datas.ua;
        this.ch_datas         = response.data.datas.check;
        this.o_material       = response.data.datas.material; 
        this.o_material_name  = response.data.datas.material_name; 
        this.o_car            = response.data.datas.car; 
        
        this.$refs.uagrid.clearSelection();
        this.e_selectData = [];
      })
      .catch((error) => { 
        this.showError(error) }
      )             
    },   
        actionComplete: function() {                             
    },  
    getReceiptNo: function() {    
      this.axios({
        method: 'get',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: `/InputCheck/WarehourseCheckNO`,
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.e_receiptno =response.data.datas;
        
        // console.log(response.data.datas)
      })
      .catch((error) => { 
        this.showError(error) }
      )             
    },     
    getWarehourseCheckList: function() {    
      this.axios({
        method: 'get',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: `/InputCheck/WarehourseCheck/List?cid=${this.e_id}`,
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.ua_select_data = response.data.datas;
      })
      .catch((error) => { 
        this.showError(error) }
      )             
    },       
    delWarehourseCheckList: function() {    
      DialogObj.hide(); 
      this.axios({
        method: 'delete',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: `/InputCheck/WarehourseCheck`,
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
        data : {
          cid : this.e_id
        }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('已刪除收料單');                
        this.getWarehourseCheck();
      })
      .catch((error) => { 
        this.showError(error) }
      )             
    },       

    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showError: function (error) {     
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showLoading() {
      Loader =this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: false, // default false
        onCancel: this.yourCallbackMethod,
        color: 'red',
        loader: 'dots',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 9999999,
      });
    },
    hideLoading() {
      Loader.hide();
    }
  },

  created() {
    this.getWarehourseCheck();
    this.$eventHub.$on('reporWharehouse', (e)=>{ 
      this.onReport(e);
    }); 
  },

  mounted() {
   
  },
  beforeUpdate() {
    
  },
  beforeDestroy() {
    this.$eventHub.$off('reporWharehouse');
  }  
}
</script>

<style scoped>
  .box {
    border-style:solid; 
    border-color: #ced2d8; 
    border-width:1px;
    border-top-width:0px; 
    padding-top: 6px; 
    padding-bottom: 6px;
    border-left-width: 0px;
    display: flex;
    align-items: center;  
  }
  .box-header {
    border-style:solid; 
    border-color: #ced2d8; 
    border-width:1px;
    border-top-width:0px; 
    padding-top: 16px; 
    padding-bottom: 16px;
    border-left-width: 0px;
  }
</style>
<style lang="scss" src="../../scss/base.scss"></style>
